var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboardCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_3405_844)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3405_844",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3405_844",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3405_844",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAc5JREFUSA2tliFORDEURa9AIBBIBALJMhAsA4lAsAgWQQIJLIAEJA4SECQsYnCQgEcgEDCneXfy/m87wwAvae7vfbe37Wvn/5Hmx5akO0kfgfT/Ne4l7YfjgST6S8eppE9JX5JeY/R79EHHiqQxj55xtGMLx0hyfUTCzYtxnvEsshkWU2ue3ZriIK0BGUfw3AwnjIhcCrhWy6XzOGM1iRPGSrCA8DhjJXfCWAkWEB5nrOROGBHk2wE/br5taD3O+KMJKtEc4i1yxkrqmY2V4K+EjY349UqUS7Mj6TJpydGHH4SNjYNko8Mv+kzSU7xGNkMD8lqBP5GEroSNjeZ7iPmtpLWOAJ48k5SwsRFyXCKXhu2zwp55WJY8ulIuGxstauFVeru28hgeRoK3L/rF9zg5sRPXPNHlcUPSs6TdSPDtoL/UBHmX2+kgOdCbqdlRmBuK3oOMTraQH5N3cB3XEnOMOdjZzZHEDl4wsbGxZWyOmlJbgoN+kPQYpaBEOX51BhziJN2i1emt2ovVZnMmRze4RXxv2UWveeV8Yql376rCk0dXAsOe2JqM1JnBrJBJ/U8DpA9PfnYe5+mj31s9vHfgydg+Z8JBkgcvXBaLvgFusKkH6CipqQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCheck);
export default __webpack_public_path__ + "static/media/clipboard-check.7638cc01b6134122b12ee0e6a47a81b0.svg";
export { ForwardRef as ReactComponent };